import $ from 'jquery';
// 未読メッセージ通知モーダル
const onShowExtra = (modalDom, modal) => {
    // 最後に通知モーダルを表示した日時を保存しておく。(その日時より新しい未読メッセージが現れたら再度通知)
    $.ajax({
        headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
        url: '/ajax/messages/notified-at',
        type: 'POST',
        dataType: 'json',
    });
};

const modalMessageNotification = {
    modalId: 'modal-message-notification',
    preventEscapeKey: false,
    onShowExtra,
    onCloseExtra: null,
    setup: null,
};

export default modalMessageNotification;
